import { render } from "./AdvertComponent.vue?vue&type=template&id=0ff91ada&scoped=true"
import script from "./AdvertComponent.vue?vue&type=script&lang=js"
export * from "./AdvertComponent.vue?vue&type=script&lang=js"

import "./AdvertComponent.vue?vue&type=style&index=0&id=0ff91ada&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff91ada"]])

export default __exports__